import React from 'react';

// After a deploy the previous build's lazily loaded chunks are gone, so a tab
// opened before it fails when it first needs one (the PDF or sheet viewer, say).
// That is "reload the app", not "this file is broken".
// Only webpack's own chunk errors: a native "Failed to fetch dynamically imported
// module" also comes from pdf.js when its worker can't start, which a reload won't fix.
const STALE_BUILD = /Loading (CSS )?chunk [\w-]+ failed/i;

export function isStaleBuildError(err) {
  return err?.name === 'ChunkLoadError' || STALE_BUILD.test(String(err?.message || ''));
}

export function StaleBuildMessage() {
  return (
    <div className="atlas-doc-viewer-message" role="alert">
      Atlas was updated since this page opened.{' '}
      <button type="button" className="atlas-doc-viewer-link" onClick={() => window.location.reload()}>
        Reload to view this file
      </button>
    </div>
  );
}

/** Keeps a viewer that fails to load or render from taking the whole app down. */
export class ViewerBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (isStaleBuildError(error)) return <StaleBuildMessage />;
    return <div className="atlas-doc-viewer-message" role="alert">This file could not be shown. Download it to open it.</div>;
  }
}
